import { GatewayInfoSocieteOrias } from "@conformite/gateway";
import { axiosInstance } from "@src/data/utils/axiosInstance";

export class GatewayInfoSocieteOriasApi {
  static async getInfoSocieteOriasBySiren(
    siren: string
  ): Promise<GatewayInfoSocieteOrias.InfoSocieteOriasType> {
    const response =
      await axiosInstance.post<GatewayInfoSocieteOrias.RetrieveInfoSocietesOriasResponseType>(
        GatewayInfoSocieteOrias.infoSocieteOriasUrl,
        {
          sirens: [siren],
          oriasIds: [],
        }
      );
    return response.data.bySiren[siren];
  }

  static async getInfoSocietesOriasBySirens(
    sirens: string[]
  ): Promise<Record<string, GatewayInfoSocieteOrias.InfoSocieteOriasType>> {
    const response =
      await axiosInstance.post<GatewayInfoSocieteOrias.RetrieveInfoSocietesOriasResponseType>(
        GatewayInfoSocieteOrias.infoSocieteOriasUrl,
        {
          sirens,
          oriasIds: [],
        }
      );
    return response.data.bySiren;
  }

  static async getCachedInfoSocietesOriasBySirens(
    sirens: string[]
  ): Promise<GatewayInfoSocieteOrias.RetrieveCachedInfoSocietesOriasResponseType> {
    const response =
      await axiosInstance.post<GatewayInfoSocieteOrias.RetrieveCachedInfoSocietesOriasResponseType>(
        `${GatewayInfoSocieteOrias.infoSocieteOriasUrl}/cached`,
        { sirens }
      );
    return response.data;
  }

  static async relaunchInfoSocietesOrias(
    sirens: string[]
  ): Promise<GatewayInfoSocieteOrias.RelaunchInfoSocietesOriasResponseType> {
    const response =
      await axiosInstance.post<GatewayInfoSocieteOrias.RelaunchInfoSocietesOriasResponseType>(
        `${GatewayInfoSocieteOrias.infoSocieteOriasUrl}/relaunch`,
        {
          sirens,
          oriasIds: [],
        }
      );
    return response.data;
  }
}
